import { Content } from "../type/content";
import axiosInstance from "./axiosInstance";

export const getContents = async ():Promise<Content[]> => await (await axiosInstance.get(`content-pages?populate[Content][populate]=*`)).data?.data